module.exports = __webpack_public_path__ + "img/slide6_vn.89124269.jpg";